/**
 * Where to send the user after crossing into the authenticated app.
 *
 * Crossing the auth boundary (login → app) uses document navigation so the
 * edge proxy sees session cookies. Soft App Router navigation is for routes
 * already inside the authenticated shell.
 */
import { resolveSafeNextPath } from '@/lib/auth/safe-next-path'

const AUTH_SHELL_PREFIXES = [
  '/login',
  '/forgot-password',
  '/reset-password',
  '/setup-account',
  '/auth',
] as const

function isAuthShellPath(pathname: string): boolean {
  return AUTH_SHELL_PREFIXES.some(
    (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
  )
}

/**
 * Resolves where to send the user after a successful sign-in.
 * Rejects open redirects and auth-shell loops (e.g. next=/login).
 */
export function resolvePostLoginDestination(next: string | null | undefined): string {
  const safe = resolveSafeNextPath(next, '/')
  const pathname = safe.split(/[?#]/, 1)[0] ?? '/'
  if (isAuthShellPath(pathname)) return '/'
  return safe
}
